/**
 * Window-event protocol of the shared document workspace. Namespaced `doc:*`
 * so it can never collide with the panel shell's `panel:*` protocol (suite
 * decision D4 of shared-panel-shell-plan, mirrored here).
 */

export const DOC_EVENTS = {
  /** A floating window's geometry changed (snap, grip resize, maximize) */
  geometryChanged: 'doc:geometry-changed',
  /** The shell asks the app to close a tab (dirty guard happens app-side) */
  requestClose: 'doc:request-close',
  /** Window-menu arrangement commands */
  floatAll: 'doc:float-all',
  consolidateAll: 'doc:consolidate-all',
  arrangeTile: 'doc:arrange-tile',
  arrangeCascade: 'doc:arrange-cascade',
  /** Reopen the most recently closed tab */
  reopenClosed: 'doc:reopen-closed',
} as const;

export const emitGeometryChanged = (docId: string): void => {
  window.dispatchEvent(
    new CustomEvent(DOC_EVENTS.geometryChanged, { detail: { docId } }),
  );
};

interface GeometryDetail {
  docId?: string;
}

export const onGeometryChanged = (
  handler: (detail: GeometryDetail) => void,
): (() => void) => {
  const listener = (event: Event) => {
    handler((event as CustomEvent).detail as GeometryDetail);
  };
  window.addEventListener(DOC_EVENTS.geometryChanged, listener);
  return () => window.removeEventListener(DOC_EVENTS.geometryChanged, listener);
};
